import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import "./follow-us.m.css";

export default function FollowUs({ isGnreach = false }) {
  const [followUsOpen, setFollowUsOpen] = useState(false);
  const iconTypes = [
    { id: "share-whatsapp", label: "Follow on Whatsapp", url: "https://whatsapp.com/channel/0029Va23xpxEFeXuMgVqck3B" },
    {
      id: "share-google",
      label: "Follow on Google",
      url: "https://news.google.com/publications/CAAqBwgKMKm6nwkw74xv?ceid=US:en&oc=3",
    },
    { id: "share-telegram", label: "Follow on Telegram", url: "https://t.me/gulfnewsUAE" },
  ];
  const icon = { width: "32px", height: "32px", viewBox: "0 0 32 32" };
  useEffect(() => {
    const closeFollowUs = () => setFollowUsOpen(false);
    document.body.addEventListener("click", closeFollowUs);

    return () => {
      document.body.removeEventListener("click", closeFollowUs);
    };
  }, []);

  return (
    <span tabIndex={0} styleName="follow-us-container" onClick={() => setFollowUsOpen(!followUsOpen)}>
      <SvgIconHandler type={isGnreach ? "follow-gnreach" : "follow"} width="100px" height="34px" viewBox="0 0 100 34" />
      {followUsOpen && (
        <div styleName="follow-us">
          {iconTypes.map((item, index) => {
            return (
              <Link key={index} href={item?.url} target="_blank">
                <SvgIconHandler type={item.id} height={icon.height} width={icon.width} viewBox={icon.viewBox} />
                {item?.label}
              </Link>
            );
          })}
        </div>
      )}
    </span>
  );
}
